import React, { useState } from "react";
import PropType from "prop-types";
import "../PlayerTableRow/PlayerTableRow.css";
import { ReactComponent as ClosedLock } from "../../../../../../assets/icons/closed-lock.svg";
import { ReactComponent as OpenLock } from "../../../../../../assets/icons/open-lock.svg";

export default function PlayerTableRow(props) {
  const selected =
    props.player.id in props.sessionSelected
      ? props.sessionSelected[props.player.id]
      : props.selectedPlayers.includes(props.player.id);

  const playerName = props.player.player.shortenedName;

  function playerSelectToggle() {
    if (selected) {
      props.updateUnsavedSelections(props.player, false, props.player.salary);
    } else {
      props.updateUnsavedSelections(props.player, true, props.player.salary);
    }
  }

  return (
    <tr
      className={
        selected
          ? "gm-player-table-row-selected"
          : "gm-player-table-row-unselected"
      }
      style={props.lastRow ? { borderBottom: "1px solid black" } : null}
    >
      <td className="gm-player-table-cell">
        <div className="gm-player-table-cell-name">
          <strong>{props.player.position}</strong> {playerName}
          {props.player.suffix ? <> ({props.player.suffix})</> : null}{" "}
          <strong>${props.player.salary}</strong>
        </div>
        {props.player.player.team ? (
          <div className="gm-player-table-cell-team">
            {props.player.player.team.abbreviation}
          </div>
        ) : null}
        {props.player.gupPercProj !== null ? (
          <div className="gm-player-table-cell-start">
            <strong>Gup&apos;s Proj Own: {props.player.gupPercProj}%</strong>
          </div>
        ) : (
          <div className="gm-player-table-cell-start">
            {props.player.slateCompetition.prettyStartTime}
          </div>
        )}
        {props.player.projPoints !== null ? (
          <div className="gm-player-table-cell-start">
            <strong>Proj Points: {props.player.projPoints}</strong>
          </div>
        ) : null}
      </td>
      <td className="gm-player-table-cell-actions">
        <div
          className="gm-player-table-select"
          role="button"
          tabIndex={0}
          onClick={(e) => {
            e.preventDefault();
            playerSelectToggle();
          }}
          onKeyPress={(e) => {
            e.preventDefault();
            playerSelectToggle();
          }}
        />

        {props.lockedPlayerIDs ? (
          props.lockedPlayerIDs.includes(props.player.id) ? (
            <ClosedLock
              className="gm-exposure-table-lock-button"
              fill="black"
              onClick={(e) => {
                e.preventDefault();
                props.togglePlayerLock(props.player.id);
              }}
            />
          ) : (
            <OpenLock
              className="gm-exposure-table-lock-button"
              fill="#ff6961"
              onClick={(e) => {
                e.preventDefault();
                props.togglePlayerLock(props.player.id);
              }}
            />
          )
        ) : null}
      </td>
    </tr>
  );
}

PlayerTableRow.propTypes = {
  player: PropType.object.isRequired,
};
